<template>
    <div>
        <div
            class="d-flex search-input d-md-none"
            id="search-hide"
            style="margin-top: 10px; width: 95.5%; margin-left: 8px"
        >
            <div
                class="search-container"
                style="width: 50%; position: relative"
            >
                <span class="search-icon">
                    <i class="fa fa-search icon-washintom"></i>
                </span>
                <input
                    type="search"
                    id="location-search"
                    placeholder="  Search Business Category"
                    class="form-control washington"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight2"
                    aria-label="Search Business Category"
                    aria-controls="offcanvasRight2"
                    readonly
                />
            </div>

            <div
                class="location-container"
                style="width: 50%; position: relative"
            >
                <span class="search-icon">
                    <i class="fas fa-map-marker-alt icon-washintom"></i>
                </span>
                <input
                    type="search"
                    id="location-search"
                    class="form-control washington"
                    data-bs-toggle="offcanvas"
                    :aria-label="`Location: ${location.city}, ${location.country_name}`"
                    data-bs-target="#offcanvasRight2"
                    aria-controls="offcanvasRight2"
                    :placeholder="`  ${location.city}, ${location.country_name}`"
                    readonly
                />
                <div
                    class="offcanvas offcanvas-end"
                    tabindex="-1"
                    id="offcanvasRight2"
                    aria-labelledby="offcanvasRightLabel2"
                >
                    <div class="offcanvas-header">
                        <a class="navbar-image" href="/">
                            <img
                                :src="getImagePath(localSettings?.logo)"
                                width="125"
                                height="44"
                                :alt="`${localSettings?.website_name} Logo`"
                            />
                        </a>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="offcanvas-body">
                        <homeSearch></homeSearch>
                    </div>
                </div>
            </div>
        </div>

        <div class="hero hero-image-wrapper">
            <div class="hero-geo-bg">
                  <canvas class="hero-canvas" ref="fxCanvas" style="z-index:1;" aria-hidden="true"></canvas>
    <svg class="hero-svg" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
        <defs>
            <pattern id="dots" width="30" height="30" patternUnits="userSpaceOnUse">
                <circle cx="1.5" cy="1.5" r="1" fill="rgba(255,94,20,0.18)"/>
            </pattern>
            <radialGradient id="og1" cx="15%" cy="50%" r="50%">
                <stop offset="0%" stop-color="#ff5e14" stop-opacity="0.35"/>
                <stop offset="100%" stop-color="#ff5e14" stop-opacity="0"/>
            </radialGradient>
            <radialGradient id="og2" cx="85%" cy="55%" r="45%">
                <stop offset="0%" stop-color="#ff5e14" stop-opacity="0.2"/>
                <stop offset="100%" stop-color="#ff5e14" stop-opacity="0"/>
            </radialGradient>
            <radialGradient id="og3" cx="50%" cy="100%" r="55%">
                <stop offset="0%" stop-color="#ff9a57" stop-opacity="0.15"/>
                <stop offset="100%" stop-color="#ff9a57" stop-opacity="0"/>
            </radialGradient>
        </defs>
        <rect width="100%" height="100%" fill="url(#dots)"/>
        <rect width="100%" height="100%" fill="url(#og1)"/>
        <rect width="100%" height="100%" fill="url(#og2)"/>
        <rect width="100%" height="100%" fill="url(#og3)"/>
        <polygon points="-100,700 250,-20 320,-20 -30,700" fill="rgba(255,94,20,0.06)"/>
        <polygon points="500,700 900,-20 960,-20 560,700" fill="rgba(255,94,20,0.04)"/>
        <path d="M -80 -80 Q 200 100 100 500" fill="none" stroke="rgba(255,94,20,0.2)" stroke-width="1.5"/>
        <path d="M -40 -80 Q 240 120 140 520" fill="none" stroke="rgba(255,94,20,0.1)" stroke-width="1"/>
        <path d="M 1100 700 Q 850 400 950 30" fill="none" stroke="rgba(255,94,20,0.18)" stroke-width="1.5"/>
        <path d="M 1130 700 Q 880 380 980 10" fill="none" stroke="rgba(255,94,20,0.09)" stroke-width="1"/>
        <polygon points="92,28 106,36 106,52 92,60 78,52 78,36" fill="none" stroke="rgba(255,94,20,0.3)" stroke-width="1"/>
        <polygon points="880,60 894,68 894,84 880,92 866,84 866,68" fill="none" stroke="rgba(255,154,87,0.25)" stroke-width="1"/>
        <polygon points="180,500 190,506 190,518 180,524 170,518 170,506" fill="none" stroke="rgba(255,94,20,0.2)" stroke-width="1"/>
        <rect x="440" y="30" width="12" height="12" fill="none" stroke="rgba(255,94,20,0.35)" stroke-width="1" transform="rotate(45 446 36)"/>
        <rect x="820" y="500" width="10" height="10" fill="none" stroke="rgba(255,154,87,0.3)" stroke-width="1" transform="rotate(45 825 505)"/>
        <rect x="120" y="100" width="8" height="8" fill="none" stroke="rgba(255,94,20,0.25)" stroke-width="1" transform="rotate(45 124 104)"/>
        <circle cx="9%" cy="18%" r="2.5" fill="rgba(255,94,20,0.6)"/>
        <circle cx="25%" cy="80%" r="2" fill="rgba(255,94,20,0.4)"/>
        <circle cx="72%" cy="12%" r="2.5" fill="rgba(255,154,87,0.55)"/>
        <circle cx="90%" cy="45%" r="2" fill="rgba(255,94,20,0.5)"/>
        <circle cx="52%" cy="90%" r="1.8" fill="rgba(255,154,87,0.35)"/>
        <circle cx="38%" cy="22%" r="1.5" fill="rgba(255,94,20,0.3)"/>
        <line x1="0" y1="100%" x2="100%" y2="100%" stroke="rgba(255,94,20,0.15)" stroke-width="2"/>
    </svg>
</div>
            <div class="overlay-content">
                <h1 class="main-heading custom-shadow">
                    Find the Best Businesses
                </h1>
                <p class="sub-heading custom-shadow">
                    Discover and connect with local businesses.
                </p>
                <div class="form-block-content default-template-gradient">
                    <div class="form-area form-four">
                        <div class="container">
                                   <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <!-- Search Type Tabs -->
                                    <div class="search-type-tabs">
                                        <button type="button" class="search-type-btn"
                                            :class="{ active: searchType === 'all' }"
                                            @click="searchType = 'all'">
                                            <i class="fas fa-search me-1"></i> All
                                        </button>
                                        <button type="button" class="search-type-btn"
                                            :class="{ active: searchType === 'businesses' }"
                                            @click="searchType = 'businesses'">
                                            <i class="fas fa-building me-1"></i> Businesses
                                        </button>
                                        <button type="button" class="search-type-btn"
                                            :class="{ active: searchType === 'services' }"
                                            @click="searchType = 'services'">
                                            <i class="fas fa-concierge-bell me-1"></i> Services
                                        </button>
                                        <button type="button" class="search-type-btn"
                                            :class="{ active: searchType === 'products' }"
                                            @click="searchType = 'products'">
                                            <i class="fas fa-box-open me-1"></i> Products
                                        </button>
                                    </div>
                                    <form @submit.prevent="debouncedProductSearchWord" class="advance_search_query">
                                        <div class="main-search-container position-relative">
                                            <div v-if="searchType === 'businesses'" class="hero-category-wrap">
                                                <select v-model="subcategoryId" class="hero-category-select"
                                                    aria-label="Select a category">
                                                    <option :value="null">All Categories</option>
                                                    <option v-for="opt in select2CategoryOptions" :key="opt.id"
                                                        :value="opt.id">{{ opt.text }}</option>
                                                </select>
                                            </div>
                                            <input type="search" name="query" class="search-input"
                                                :placeholder="searchPlaceholder"
                                                v-model="searchQuery" autocomplete="off"
                                                :aria-label="searchPlaceholder" 
                                                @input="onSearchInput"
                                                @focus="showSuggestions = true" />
                                            <button type="submit" class="search-button" :disabled="loading">
                                                <span v-if="loading" class="spinner-border spinner-border-sm me-2"
                                                    role="status" aria-hidden="true"></span>
                                                <span v-else><i class="fas fa-search pe-1"></i> Find</span>
                                            </button>

                                            <!-- Autocomplete Suggestions Dropdown -->
                                      <!-- Autocomplete Suggestions Dropdown -->
<div v-if="showSuggestions && searchQuery.length >= 3" class="suggestions-dropdown" v-click-outside="closeSuggestions">
    <div v-if="isSearchingSuggestions" class="text-center p-3 text-muted scale-up">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Searching...
    </div>
    <div v-else-if="!hasSuggestions" class="text-center p-3 text-muted scale-up">
        No results found for "{{ searchQuery }}"
    </div>
    <div v-else class="suggestions-columns text-start">

        <!-- Businesses -->
        <div class="suggestions-col" v-if="suggestions.businesses && suggestions.businesses.length">
            <h6 class="suggestion-header" v-if="searchType == 'all'">
                <i class="fas fa-building me-2"></i>Businesses
            </h6>
            <a href="#" v-for="business in suggestions.businesses" :key="'bus_'+business.id"
               @click.prevent="goToSuggestion('business', business)" class="suggestion-item">
                <div class="suggest-img-wrap me-2">
                    <img :src="getImagePath(business.business_logo || 'images/default.png')" class="suggest-img" width="40" height="40" loading="lazy" :alt="business.business_name">
                </div>
                <div class="suggest-content">
                    <span class="suggest-title">{{ business.business_name }}</span>
                </div>
            </a>
        </div>

        <!-- Services -->
        <div class="suggestions-col" v-if="suggestions.services && suggestions.services.length">
            <h6 class="suggestion-header" v-if="searchType == 'all'">
                <i class="fas fa-concierge-bell me-2"></i>Services
            </h6>
            <a href="#" v-for="service in suggestions.services" :key="'srv_'+service.id"
               @click.prevent="goToSuggestion('service', service)" class="suggestion-item">
                <div class="suggest-img-wrap me-2">
                    <img :src="getImagePath(service.image || 'images/default.png')" class="suggest-img" width="40" height="40" loading="lazy" :alt="service.name">
                </div>
                <div class="suggest-content">
                    <span class="suggest-title">{{ service.name }}</span>
                    <small class="suggest-subtitle" v-if="service.business">by {{ service.business.business_name }}</small>
                </div>
            </a>
        </div>

        <!-- Products -->
        <div class="suggestions-col" v-if="suggestions.products && suggestions.products.length">
            <h6 class="suggestion-header" v-if="searchType == 'all'">
                <i class="fas fa-box-open me-2"></i>Products
            </h6>
            <a href="#" v-for="product in suggestions.products" :key="'prd_'+product.id"
               @click.prevent="goToSuggestion('product', product)" class="suggestion-item">
                <div class="suggest-img-wrap me-2">
                    <img :src="getImagePath(product.product_image || 'images/default.png')" class="suggest-img" width="40" height="40" loading="lazy" :alt="product.name">
                </div>
                <div class="suggest-content">
                    <span class="suggest-title">{{ product.name }}</span>
                    <small class="suggest-subtitle" v-if="product.business">by {{ product.business.business_name }}</small>
                </div>
            </a>
        </div>

    </div>
</div>
                                        </div>
                                    </form>
                                </div><!-- /.col-md-12 -->
                            </div><!-- /.row -->
                        </div><!-- /.container -->
                    </div><!-- /.form-area -->
                </div>

                <!-- Cookie -->
                <div
                    v-if="showCookieBanner"
                    class="cookie-banner"
                    ref="cookieSection"
                >
                    <div class="container">
                        <div class="cookie-flex">
                            <div class="cookie-icon">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#ff5e14"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path
                                        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c.316 0 .63.013.94.039A3.5 3.5 0 0 0 17 5.5a3.5 3.5 0 0 0 4.461 3.361A10 10 0 0 1 12 22z"
                                    />
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="1"
                                        fill="#ff5e14"
                                    />
                                    <circle
                                        cx="7.5"
                                        cy="14.5"
                                        r="1"
                                        fill="#ff5e14"
                                    />
                                    <circle
                                        cx="15"
                                        cy="9"
                                        r="1"
                                        fill="#ff5e14"
                                    />
                                </svg>
                            </div>
                            <div class="cookie-text">
                                <p class="cookie-title">We use cookies</p>
                                <p class="cookie-desc">
                                    We use cookies to improve your experience
                                    and show relevant ads.
                                    <a
                                        @click="cookieBtn('manage')"
                                        class="policy-link"
                                        href="#"
                                        >Learn more</a
                                    >
                                </p>
                            </div>
                            <div class="cookie-actions">
                                <button
                                    class="cookie-btn-manage"
                                    @click="cookieBtn('manage')"
                                >
                                    Manage
                                </button>
                                <button
                                    class="cookie-btn-accept"
                                    @click="cookieBtn('accept')"
                                >
                                    Accept all
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="custom-category-container">
                    <Carousel
                        v-bind="categoriesCarouselConfig"
                        class="mt-5 pt-0 pt-md-2 pt-lg-5"
                    >
                        <Slide
                            v-for="(category, index) in categories"
                            :key="index"
                        >
                            <router-link
                                class="custom-category-link"
                                :to="{
                                    name: 'category',
                                    params: { category: category.slug },
                                }"
                            >
                                <div class="item-box">
                                    <div class="image-box">
                                        <img
                                            width="40"
                                            height="40"
                                            loading="lazy"
                                            class="item-image"
                                            style="object-fit: contain"
                                            :src="getImagePath(category.image)"
                                            alt=""
                                        />
                                    </div>
                                    <span class="item-name">{{
                                        category.name
                                    }}</span>
                                </div>
                            </router-link>
                        </Slide>
                    </Carousel>
                </div>
            </div>
        </div>

        <!-- Featured Listing (hidden when there are no featured businesses) -->
        <section
            v-if="featured_businessess_loading || (featured_businessess && featured_businessess.length)"
            class="container mt-5"
            aria-labelledby="featured-listing-heading"
        >
            <h2
                id="featured-listing-heading"
                class="section-heading text-center mb-5"
            >
                Featured Listing
            </h2>
            <div class="row">
                <ShimmerCard v-if="featured_businessess_loading"></ShimmerCard>
                <Carousel v-bind="dynamicCarouselOptions" v-else>
                    <Slide
                        v-for="business in loopedBusinesses"
                        :key="business.id"
                    >
                        <BusinessCart :business="business"></BusinessCart>
                    </Slide>
                </Carousel>
            </div>
        </section>

        <!-- Top Categories -->
        <section
            class="container my-5"
            aria-labelledby="top-categories-heading"
        >
            <h2
                id="top-categories-heading"
                class="section-heading text-center mb-4"
            >
                Top Categories
            </h2>
            <div class="row g-3 g-md-4">
                <div
                    class="col-6 col-md-3"
                    v-for="(column, index) in columns"
                    :key="index"
                >
                    <div class="bg-white border rounded-4 shadow-sm p-3 h-100">
                        <ul class="list-unstyled m-0">
                            <li>
                                <router-link
                                    v-for="(subcategory, subIndex) in column"
                                    :key="subIndex"
                                    :to="{
                                        name: 'category',
                                        params: {
                                            category: subcategory.category_slug,
                                            sub_category: subcategory.slug,
                                        },
                                    }"
                                    class="d-flex justify-content-between align-items-center py-2 px-2 mb-2 text-decoration-none rounded category-item"
                                >
                                    <div class="d-flex align-items-center">
                                        <i
                                            :class="
                                                subcategory.icon_picker ||
                                                'fas fa-tags'
                                            "
                                            class="me-2 fs-5"
                                            aria-hidden="true"
                                            style="color: #ff5e14"
                                        ></i>
                                        <span
                                            class="category-name fw-medium text-dark"
                                            >{{ subcategory.name }}</span
                                        >
                                    </div>
                                    <span
                                        class="badge rounded-pill bg-light text-dark border border-1 px-3 py-1"
                                    >
                                        {{ subcategory.count }}
                                    </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!-- Testimonial Section -->
        <section class="bg-light mt-5" aria-labelledby="testimonial-heading">
            <div class="container pt-5">
                <h2
                    id="testimonial-heading"
                    class="section-heading text-center mb-5"
                >
                    What do Company Owners Say?
                </h2>
                <div class="row">
                    <div class="col-md-4">
                        <div class="column row">
                            <article class="large-12 columns testimonial">
                                <blockquote class="quote">
                                    <p>
                                        Our business has seen a tremendous boost
                                        since listing on this directory. The
                                        user-friendly interface made it easy to
                                        set up our profile, and we've been able
                                        to attract new customers consistently.
                                        Highly recommend for businesses looking
                                        to increase their visibility!
                                    </p>
                                </blockquote>
                                <div class="student">
                                    <div class="photo round-image">
                                        <img
                                            width="60"
                                            height="60"
                                            alt="Photo of Muhammad Bilawal"
                                            src="/images/profile/testimonial-profile.webp"
                                        />
                                    </div>
                                    <p>Muhammad Bilawal</p>
                                    <p>CEO, Coding Crust</p>
                                </div>
                            </article>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="column row">
                            <article class="large-12 columns testimonial">
                                <blockquote class="quote">
                                    <p>
                                        This platform has been a game-changer
                                        for us. The exposure we’ve received has
                                        brought in clients from areas we hadn't
                                        reached before. The customer service is
                                        also top-notch, making sure all our
                                        questions were answered quickly. It’s an
                                        essential tool for growing businesses!
                                    </p>
                                </blockquote>
                                <div class="student">
                                    <div class="photo round-image">
                                        <img
                                            width="60"
                                            height="60"
                                            alt="Photo of Fahad Rajput"
                                            src="/images/profile/testimonial-profile.webp"
                                        />
                                    </div>
                                    <p>Fahad Rajput</p>
                                    <p>Manager, Project Estimate Buildups</p>
                                </div>
                            </article>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="column row">
                            <article class="large-12 columns testimonial">
                                <blockquote class="quote">
                                    <p>
                                        We’re thrilled with the results from
                                        this directory! It's streamlined, easy
                                        to use, and has significantly improved
                                        our online presence. The traffic we get
                                        from here has led to meaningful business
                                        connections and new opportunities.
                                    </p>
                                </blockquote>
                                <div class="student">
                                    <div class="photo round-image">
                                        <img
                                            width="60"
                                            height="60"
                                            alt="Photo of Eddy Goyor"
                                            src="/images/profile/testimonial-profile.webp"
                                        />
                                    </div>
                                    <p>Eddy Goyor</p>
                                    <p>CEO, Ikae Digital</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import Rating from "./include/Rating";
import { mapState, mapActions } from "vuex";
import { nextTick } from "vue";
import BusinessCart from "./Business-cart.vue";
import { useHead } from "@vueuse/head";
import homeSearch from "./include/homeSerach.vue";
import ShimmerCard from "../components/shimmer/Shimmer.vue";
import { toast } from "vue3-toastify";
import { getImagePath } from "../utils/helpers";
import axios from "axios";
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

export default {
    components: {
        Rating,
        BusinessCart,
        homeSearch,
        ShimmerCard,
        Carousel,
        Slide,
    },
    setup() {
        useHead({
            title: "Bizrar - Pakistan’s Leading Business Directory & Local Listings",
            meta: [
                // Meta Description
                {
                    name: "description",
                    content:
                        "Find and list top businesses across Pakistan with Bizrar. Discover trusted services, local shops, professionals, and companies near you. Grow your business online today!",
                },

                // Optimized Keywords
                {
                    name: "keywords",
                    content:
                        "Pakistan business directory, local business listings Pakistan, online directory Pakistan, free business listing site, list your business Pakistan, find services Pakistan, Lahore Karachi Islamabad businesses, B2B directory Pakistan, small business listings, local company directory",
                },

                // Open Graph (Facebook & Others)
                { property: "og:type", content: "website" },
                {
                    property: "og:title",
                    content:
                        "Bizrar - Pakistan’s Leading Business Directory & Local Listings",
                },
                {
                    property: "og:description",
                    content:
                        "Search top businesses in Pakistan. List your business, explore services, and connect with verified professionals at Bizrar.",
                },
                { property: "og:url", content: "https://bizrar.com" },
                {
                    property: "og:image",
                    content:
                        "https://bizrar.com/images/bizrar-business-directory.png",
                },
                { property: "og:image:width", content: "880" },
                { property: "og:image:height", content: "660" },
                { property: "og:locale", content: "en_US" },
                { property: "og:site_name", content: "BIZRAR" },

                // Twitter Card
                { name: "twitter:card", content: "summary_large_image" },
                { name: "twitter:site", content: "https://bizrar.com/" },
                { name: "twitter:creator", content: "@bizrar" },
                {
                    name: "twitter:title",
                    content:
                        "Bizrar - Pakistan’s Leading Business Directory & Local Listings",
                },
                {
                    name: "twitter:description",
                    content:
                        "Explore verified Pakistani businesses and services. Join Bizrar and increase your visibility in the local online market.",
                },
                {
                    name: "twitter:image",
                    content:
                        "https://bizrar.com/images/bizrar-business-directory.png",
                },

                // Robots & Authors
                { name: "robots", content: "index, follow" },
                { name: "googlebot", content: "index, follow" },
                { name: "author", content: "Bizrar" },
                { name: "publisher", content: "Coding Crust" },
            ],
            link: [{ rel: "canonical", href: "https://bizrar.com/" }],
        });
    },
    data() {
        return {
            categoriesCarouselConfig: {
                itemsToShow: 10,
                wrapAround: true,
                autoplay: 3000,
                itemsToScroll: 1,
                mouseDrag: true,
                touchDrag: true,
                gap: 10,
                snapAlign: "start",
                breakpointMode: "carousel",
                breakpoints: {
                    0: { itemsToShow: 1 },
                    350: { itemsToShow: 2 },
                    500: { itemsToShow: 3 },
                    768: { itemsToShow: 4 },
                    1000: { itemsToShow: 5 },
                    1200: { itemsToShow: 6 },
                    1400: { itemsToShow: 8 },
                    1600: { itemsToShow: 10 },
                },
            },
            businessCarouselOptions: {
                itemsToShow: 4,
                autoplay: 3000,
                itemsToScroll: 1,
                mouseDrag: true,
                touchDrag: true,
                gap: 10,
                snapAlign: "start",
                breakpointMode: "carousel",
                breakpoints: {
                    0: { itemsToShow: 1 },
                    768: { itemsToShow: 2 },
                    1000: { itemsToShow: 3 },
                    1200: { itemsToShow: 4 },
                },
            },
            columnCount: 4,
            searchQuery: "",
            searchType: "all",
            countryId: 0,
            cityId: 0,
            showCookieBanner: true,
            loading: false,
            subcategoryId: null,
            
            // Autocomplete suggestions
            showSuggestions: false,
            isSearchingSuggestions: false,
            suggestions: {
                businesses: [],
                services: [],
                products: []
            },
            suggestionTimeout: null,
            localSettings: {},
        };
    },
    methods: {
        ...mapActions("business", ["featuredBusinesses"]),
        ...mapActions("home", [
            "fetchCategories",
            "getLocation",
            "setLocation",
        ]),
        getImagePath,
        initHeroAnimations() {
            // Single-canvas hero FX (was 4 canvases + a full-width grid redraw every
            // frame). Cheap glow "blobs" + a few floating particles, capped at ~30fps,
            // paused when off-screen or the tab is hidden, and skipped entirely for
            // users who prefer reduced motion. The static gradient + SVG carry the look.
            const wrap = this.$el.querySelector('.hero-geo-bg');
            const canvas = this.$refs.fxCanvas;
            if (!wrap || !canvas) return;

            const reduce = window.matchMedia
                && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduce) return;

            const ctx = canvas.getContext('2d');
            const rand = (a, b) => Math.random() * (b - a) + a;
            let W = 0, H = 0, blobs = [], parts = [];

            const build = () => {
                W = wrap.offsetWidth; H = wrap.offsetHeight;
                canvas.width = W; canvas.height = H;
                blobs = [
                    { ox: W * 0.15, oy: H * 0.5,  r: W * 0.28, t: 0, ts: 0.004, ax: W * 0.07, ay: H * 0.09, op: 0.20, col: [255, 94, 20] },
                    { ox: W * 0.82, oy: H * 0.55, r: W * 0.22, t: 2, ts: 0.003, ax: W * 0.05, ay: H * 0.07, op: 0.13, col: [255, 154, 87] },
                    { ox: W * 0.5,  oy: H * 0.9,  r: W * 0.30, t: 4, ts: 0.005, ax: W * 0.06, ay: H * 0.05, op: 0.11, col: [255, 94, 20] },
                ];
                const count = W < 768 ? 14 : 28; // far fewer than the old 55 + 70 stars
                parts = Array.from({ length: count }, () => ({
                    x: rand(0, W), y: rand(0, H), r: rand(1, 2.4),
                    op: rand(0.15, 0.5), sy: rand(0.15, 0.5), sx: rand(-0.1, 0.1),
                    pulse: rand(0, Math.PI * 2), ps: rand(0.01, 0.022),
                    col: Math.random() > 0.4 ? [255, 94, 20] : [255, 154, 87],
                }));
            };

            const frame = () => {
                ctx.clearRect(0, 0, W, H);
                blobs.forEach(b => {
                    b.t += b.ts;
                    const x = b.ox + Math.sin(b.t) * b.ax;
                    const y = b.oy + Math.cos(b.t * 0.7) * b.ay;
                    const g = ctx.createRadialGradient(x, y, 0, x, y, b.r);
                    g.addColorStop(0, `rgba(${b.col[0]},${b.col[1]},${b.col[2]},${b.op})`);
                    g.addColorStop(1, `rgba(${b.col[0]},${b.col[1]},${b.col[2]},0)`);
                    ctx.beginPath(); ctx.arc(x, y, b.r, 0, Math.PI * 2);
                    ctx.fillStyle = g; ctx.fill();
                });
                parts.forEach(p => {
                    p.pulse += p.ps;
                    const a = p.op * (0.5 + 0.5 * Math.sin(p.pulse));
                    ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                    ctx.fillStyle = `rgba(${p.col[0]},${p.col[1]},${p.col[2]},${a})`; ctx.fill();
                    p.y -= p.sy; p.x += p.sx;
                    if (p.y < -5) { p.y = H + 5; p.x = rand(0, W); }
                    if (p.x < -5) p.x = W + 5; else if (p.x > W + 5) p.x = -5;
                });
            };

            const interval = 1000 / 30;
            let lastTs = 0;
            const loop = (ts) => {
                this._heroRAF = requestAnimationFrame(loop);
                if (ts - lastTs < interval) return;
                lastTs = ts;
                frame();
            };
            const start = () => {
                if (this._heroRAF || this._heroPaused) return;
                this._heroRAF = requestAnimationFrame(loop);
            };
            const stop = () => {
                if (this._heroRAF) { cancelAnimationFrame(this._heroRAF); this._heroRAF = null; }
            };

            build();
            this._heroPaused = false;

            const heroEl = this.$el.querySelector('.hero-image-wrapper') || wrap;
            if ('IntersectionObserver' in window) {
                this._heroIO = new IntersectionObserver((entries) => {
                    const visible = entries[0].isIntersecting;
                    this._heroPaused = !visible;
                    if (visible && !document.hidden) start(); else stop();
                }, { threshold: 0 });
                this._heroIO.observe(heroEl);
            } else {
                start();
            }

            this._heroVis = () => {
                if (document.hidden) stop();
                else if (!this._heroPaused) start();
            };
            document.addEventListener('visibilitychange', this._heroVis);

            let rt;
            this._heroResize = () => { clearTimeout(rt); rt = setTimeout(build, 200); };
            window.addEventListener('resize', this._heroResize);
        },
        async fetchSuggestions() {
            if (!this.searchQuery || this.searchQuery.length < 3) {
                this.suggestions = { businesses: [], services: [], products: [] };
                this.isSearchingSuggestions = false;
                return;
            }
            
            this.isSearchingSuggestions = true;
            this.showSuggestions = true;
            
            try {
                const response = await axios.get('/api/search/suggestions', {
                    params: {
                        query: this.searchQuery,
                        type: this.searchType
                    }
                });
                this.suggestions = response.data;
            } catch (error) {
                console.error("Error fetching suggestions:", error);
                this.suggestions = { businesses: [], services: [], products: [] };
            } finally {
                this.isSearchingSuggestions = false;
            }
        },
        onSearchInput() {
            clearTimeout(this.suggestionTimeout);
            this.suggestionTimeout = setTimeout(() => {
                this.fetchSuggestions();
            }, 300);
        },
        closeSuggestions() {
            this.showSuggestions = false;
        },
        goToSuggestion(type, item) {
            this.closeSuggestions();
            if (type === 'business') {
                this.$router.push({ name: 'single-business', params: { slug: item.slug } });
            } else if (type === 'service') {
                this.$router.push({ name: 'service-page', params: { slug: item.slug } });
            } else if (type === 'product') {
                this.$router.push({ name: 'single-product', params: { id: item.id } });
            }
        },
        debouncedProductSearchWord: debounce(function () {
            this.showSuggestions = false; // Close suggestions dropdown when submitting
            
            if (this.searchQuery) {
                if (this.searchQuery.length >= 3) {
                    if (this.searchType === 'all') {
                        this.$router.push({
                            name: 'search-all',
                            query: { search: this.searchQuery },
                        });
                    } else if (this.searchType === 'services') {
                        this.$router.push({
                            name: 'search-services',
                            query: { search: this.searchQuery },
                        });
                    } else if (this.searchType === 'products') {
                        this.$router.push({
                            name: 'search-products',
                            query: { search: this.searchQuery },
                        });
                    } else {
                        const router = {
                            name: "category",
                            params: {},
                            query: {
                                search: this.searchQuery,
                            },
                        };

                        if (this.selectedSubcategory) {
                            router.params.category =
                                this.selectedSubcategory.category_slug;
                            router.params.sub_category =
                                this.selectedSubcategory.slug;
                        }

                        this.$router.push(router);
                    }
                } else {
                    toast.error("Search term must be 3 characters long.");
                }
            } else {
                toast.error("Please provide search terms.");
            }
        }, 500),

        cookieBtn(key) {
            if (key === "manage") {
                this.$router.push("/cookies-policy");
            } else {
                this.$refs.cookieSection.classList.add("d-none"); // Hide the cookie banner properly
                localStorage.setItem("cookieAccepted", "true");
            }
        },
    },

    computed: {
        ...mapState("home", [
            "categories",
            "subcategories",
            "location",
            "category_loading",
            "settings",
        ]),
        ...mapState("business", [
            "featured_businessess",
            "featured_businessess_loading",
            "country",
        ]),
        // "Top Categories": the most-listed subcategories (by count), split into columns.
        // A computed (not an async setColumns) so it is populated on the very first render
        // from the seeded subcategories — the section no longer grows from empty -> filled
        // a tick later (which caused a ~0.1 CLS). Limited so it isn't a 200-item wall.
        columns() {
            if (!this.subcategories || !this.subcategories.length) return [];
            const TOP_LIMIT = 40;
            const subs = [...this.subcategories]
                .sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0))
                .slice(0, TOP_LIMIT);
            const columnLength = Math.ceil(subs.length / this.columnCount);
            const cols = [];
            for (let i = 0; i < this.columnCount; i++) {
                cols.push(subs.slice(i * columnLength, (i + 1) * columnLength));
            }
            return cols;
        },
        loopedBusinesses() {
            if (!this.featured_businessess.length) return [];

            // Repeat items until we have at least 10
            const minItems = 10;
            let items = [...this.featured_businessess];
            while (items.length < minItems) {
                items = [...items, ...this.featured_businessess];
            }
            return items;
        },
        dynamicCarouselOptions() {
            return {
                ...this.businessCarouselOptions,
                wrapAround: false,
            };
        },
        filteredBusinessOrder() {
            return this.featured_businessess.filter((Business) =>
                Business.business_name
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase())
            );
        },
        select2CategoryOptions() {
            return this.subcategories.map((item) => ({
                id: item.id,
                text: item.name,
                slug: item.slug,
                category_slug: item.category_slug,
            }));
        },
        selectedSubcategory() {
            return this.select2CategoryOptions.find(
                (option) => option.id == this.subcategoryId
            );
        },
        searchPlaceholder() {
    const labels = {
        all: 'Search businesses, services & products...',
        businesses: 'Search businesses...',
        services: 'Search any services...',
        products: 'Search any products...',
    };
    return labels[this.searchType] || labels.all;
},
        hasSuggestions() {
            return (this.suggestions.businesses && this.suggestions.businesses.length > 0) ||
                   (this.suggestions.services && this.suggestions.services.length > 0) ||
                   (this.suggestions.products && this.suggestions.products.length > 0);
        },
        filteredBusinessDetail() {
            return this.featured_businessess.filter((Business) =>
                Business.business_name
                    .toLowerCase()
                    .includes(this.whichQuery.toLowerCase())
            );
        },
    },
    watch: {
        "location.country_id"(newValue) {
            this.countryId = newValue;
        },
        "location.city_id"(newValue) {
            this.cityId = newValue;
        },
        settings: {
            handler(newValue) {
                this.localSettings = newValue;
            },
            immediate: true,
        },
        searchType() {
            // When tab changes, fetch suggestions for that tab type if there is a query
            if (this.searchQuery && this.searchQuery.length >= 3) {
                this.fetchSuggestions();
            }
        }
    },
    mounted() {
        // requestAnimationFrame (not $nextTick) so the offsetWidth/offsetHeight read
        // inside initHeroAnimations lands after the browser's own paint/layout pass
        // instead of forcing an early synchronous reflow of everything else Vue,
        // Bootstrap and the carousel wrote to the DOM during this same mount —
        // that forced reflow showed up as ~60ms of blocking time in production.
        requestAnimationFrame(() => { this.initHeroAnimations(); });

        // Featured/categories are seeded from window.__BOOT__ on the server-rendered
        // home page — only hit the API when that boot payload is absent (e.g. when the
        // user navigates here client-side from another SPA route). Avoids a redundant
        // request and the shimmer flash over already-rendered content.
        if (!this.featured_businessess || this.featured_businessess.length === 0) {
            this.featuredBusinesses();
        }
        if (this.location.city_id && this.location.country_id) {
            this.countryId = this.location.country_id;
            this.cityId = this.location.cityId;
        }
        if (localStorage.getItem("cookieAccepted") === "true") {
            this.showCookieBanner = false;
        }

        // Click outside directive for closing suggestions dropdown
        const app = this.$.appContext.app;
        if (!app.directive('click-outside')) {
            app.directive('click-outside', {
                mounted(el, binding) {
                    el.clickOutsideEvent = function (event) {
                        if (!(el == event.target || el.contains(event.target))) {
                            binding.value(event);
                        }
                    };
                    document.body.addEventListener('click', el.clickOutsideEvent);
                },
                unmounted(el) {
                    document.body.removeEventListener('click', el.clickOutsideEvent);
                },
            });
        }
    },
    beforeUnmount() {
        // Stop hero FX + release all listeners so nothing keeps running after the user
        // navigates away in the SPA (previously the RAF loop leaked forever).
        if (this._heroRAF) cancelAnimationFrame(this._heroRAF);
        if (this._heroIO) this._heroIO.disconnect();
        if (this._heroVis) document.removeEventListener('visibilitychange', this._heroVis);
        if (this._heroResize) window.removeEventListener('resize', this._heroResize);
    },
};
</script>

<style scoped>
.hero-canvas {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    pointer-events: none;
}
.hero-image-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 700px;
    color: #fff;
    text-align: center;
    background: linear-gradient(135deg, #0f0f1a 0%, #1a1025 40%, #2a1010 100%);
}

.hero-geo-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.hero-svg {
    width: 100%;
    height: 100%;
    display: block;
}

.hero-image-wrapper .overlay-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
}
.section-heading {
    font-size: 2rem;
    font-weight: 700;
    background: linear-gradient(135deg, #ff5e14, #ff9a57);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: -0.5px;
}

.section-heading::after {
    content: "";
    display: block;
    width: 60px;
    height: 3px;
    border-radius: 2px;
    margin: 8px auto 0;
    background: linear-gradient(135deg, #ff5e14, #ff9a57);
}
/* Advance Search Bar */

/* Search Type Tabs */
.search-type-tabs {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin: 30px auto 0;
    max-width: 850px;
}

.search-type-btn {
    padding: 10px 24px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
}

.search-type-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: #fff;
}

.search-type-btn.active {
    background: #fff;
    /* deep brand orange — keeps WCAG AA contrast on white */
    color: #c74800;
    border-color: #fff;
    box-shadow: 0 4px 15px rgba(255, 94, 20, 0.3);
}

@media (max-width: 767px) {
    .search-type-tabs {
        gap: 4px;
        margin-top: 20px;
        flex-wrap: wrap;
    }

    .search-type-btn {
        padding: 8px 14px;
        font-size: 12px;
    }
}

.position-relative {
    position: relative;
}

.main-search-container {
    display: flex;
    align-items: center;
    max-width: 850px;
    margin: 15px auto 40px;
    background: #fff;
    border-radius: 8px;
    overflow: visible;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
}
.main-search-container .search-input:first-child {
    border-radius: 8px 0 0 8px;
}

.search-button {
    border-radius: 0 8px 8px 0; /* add this to existing styles */
}
.main-search-container:hover {
    box-shadow: 0 10px 30px rgba(255, 94, 20, 0.25);
}

.main-search-container .search-input {
    flex: 1;
    padding: 16px 22px;
    border: none;
    outline: none;
    font-size: 16px;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    color: #333;
    background: transparent;
}

.main-search-container .search-input::placeholder {
    color: #555;
    font-weight: 400;
}

.search-button {
    background: linear-gradient(135deg, #ff5e14, #ff7840);
    color: #fff;
    font-weight: 600;
    border: none;
    padding: 18px 28px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 15px;
    min-width: 109px;
    height: 57px;
}

.search-button i {
    font-size: 16px;
}

.search-button:hover {
    background: linear-gradient(135deg, #ff7840, #ff5e14);
}

.search-button:disabled {
    cursor: not-allowed;
}

.custom-category-container::-webkit-scrollbar {
    display: none;
}

/* Reserve a minimum height so the row doesn't collapse before the carousel populates,
   but let it grow to fit the cards fully (a fixed height + overflow:hidden was clipping
   the category tiles). */
.custom-category-container {
    min-height: 210px;
}

.item-box {
    height: 170px;
    width: 166px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #313131;
    background-color: #ffffff !important;
    box-sizing: border-box;
    text-align: center;
    float: left;
    border-radius: 12px;
}

.item-box .image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fd7c3f;
    padding: 20px;
    border-radius: 200px;
    width: 79px;
    height: 77px;
}

.item-box img {
    width: 100%;
    height: auto;
}

.item-box .item-name {
    margin-top: 10px;
    font-weight: bold;
    min-height: 42px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    padding: 0 6px;
}

.main-heading {
    display: block;
    text-transform: uppercase;
    font-size: 58px;
    line-height: 60px;
    font-weight: 700;
    padding-top: 116px;
}

/* Search Bar */
@media screen and (min-width: 480px) {
    .form-bg {
        padding: 30px 15px;
    }
}
/* Banner */
.cookie-banner {
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 40px);
    max-width: 900px;
    background: #fff;
    border: 1px solid #ff5e14;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
    padding: 14px 0;
    z-index: 9999;
    border-radius: 15px;
}

/* Flex row */
.cookie-flex {
    display: flex;
    align-items: center;
    gap: 14px;
}

/* Icon */
.cookie-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    background: #fff4f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Text */
.cookie-text {
    flex: 1;
}

.cookie-title {
    font-weight: 700;
    font-size: 14px;
    color: #c74800;
    margin: 0 0 2px 0;
}

.cookie-desc {
    font-size: 13px;
    color: #555;
    margin: 0;
}

.policy-link {
    color: #ff5e14;
    text-decoration: underline;
    font-weight: 500;
}

.policy-link:hover {
    color: #cc4b11;
}

/* Buttons */
.cookie-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.cookie-btn-manage {
    background: transparent;
    color: #c74800;
    border: 1.5px solid #ff5e14;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.cookie-btn-manage:hover {
    background: #fff4f0;
}

.cookie-btn-accept {
    background: #c74800;
    color: #fff;
    border: 1.5px solid #c74800;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.cookie-btn-accept:hover {
    background: #cc4b11;
    border-color: #cc4b11;
}

@media only screen and (max-width: 576px) {
    .cookie-banner {
        bottom: 10px;
        width: calc(100% - 20px);
        left: 50%;
        transform: translateX(-50%);
    }

    .cookie-flex {
        flex-wrap: wrap;
    }

    .cookie-actions {
        width: 100%;
        justify-content: flex-end;
    }

    .mobile-w-100 {
        width: 100% !important;
    }

    .main-heading {
        padding-top: 70px;
    }
}

@media (max-width: 767px) {
    .main-heading {
        font-size: 28px;
        line-height: 35px;
    }

    .main-search-container {
        flex-wrap: wrap;
        gap: 2px;
        border-radius: 21px;
    }

    .hero-category-wrap {
        width: 100%;
    }

    .hero-category-select {
        width: 100%;
        max-width: none;
        min-width: 0;
        height: 48px;
        border-right: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 8px 8px 0 0;
    }

    .main-search-container .search-input {
        border: 1px solid rgba(0, 0, 0, 0.2) !important;
    }

    .main-search-container .search-button {
        width: 100% !important;
        border-radius: 0 !important;
    }
}

@media only screen and (min-width: 768px) {
    .cookie_section {
        width: 50% !important;
    }
}

.main-search-container {
    position: relative;
}

.search-icon {
    position: absolute;
    top: 29%;
    left: 10px;
    transform: translateY(-50%);
    color: #aaa;
}

#location-search {
    padding-left: 35px;
}

.icon-washintom {
    margin-top: 15px !important;
}

@media only screen and (max-width: 767px) {
    /* Must stay tall enough to contain the categories carousel that straddles the
       hero's bottom edge (the carousel bottom sits ~800px down); a shorter hero +
       overflow:hidden clipped the category tiles. Matches the server-rendered
       .ssr-hero height so there is no layout shift on Vue mount. */
    .hero-image-wrapper {
        height: 700px !important;
    }

    .country {
        width: 100% !important;
    }
}

.category-item {
    transition: all 0.2s ease-in-out;
    background-color: #fff;
    border: 1px solid #f2f2f2;
    padding: 12px !important;
    gap: 6px;
}

/* Let the icon+name group shrink and the name truncate so the count badge never
   overflows the narrow col-6 card on mobile (was pushing the page 8px wide). */
.category-item > .d-flex {
    min-width: 0;
    flex: 1 1 auto;
}
.category-item .category-name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.category-item .badge {
    flex: 0 0 auto;
}

@media (max-width: 575px) {
    .category-item {
        padding: 8px !important;
    }
    .category-item i {
        font-size: 1rem !important;
    }
    .category-item .badge {
        padding-left: 8px !important;
        padding-right: 8px !important;
    }
}

.category-item:hover {
    background-color: #ff5e14;
    color: #fff !important;
    transform: translateY(-2px);
}

.category-item:hover i {
    color: #fff !important;
}

.category-item:hover .badge {
    background-color: #fff !important;
    color: #ff5e14;
    border-color: transparent;
}

.category-item:hover .category-name {
    color: #fff !important;
}

.form-control {
    padding: 0.75rem 1.75rem !important;
    border-radius: 2px !important;
}

/* Lightweight native category dropdown (replaces heavy Select2 + jQuery on the home page) */
.hero-category-wrap {
    position: relative;
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
}

.hero-category-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 100%;
    min-width: 170px;
    max-width: 210px;
    padding: 0 34px 0 20px;
    border: none;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    background: transparent;
    color: #333;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    border-radius: 8px 0 0 8px;
    /* custom chevron */
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23ff5e14' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>");
    background-repeat: no-repeat;
    background-position: right 12px center;
}

.hero-category-select:focus-visible {
    box-shadow: inset 0 0 0 2px rgba(255, 94, 20, 0.35);
}

.hero-category-select option {
    color: #333;
}

.custom-category-link {
    width: 100%;
}

.item-box {
    width: 100%;
}

.hero-image-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 700px;
    color: #fff;
    text-align: center;
}

.hero-image-wrapper .hero-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.hero-image-wrapper .overlay-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
}

/* Suggestions Dropdown */
.suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 8px;
    margin-top: 5px;
    z-index: 1000;
    color: #333;
    border: 1px solid #eee;
}

.suggestions-columns {
    display: flex;
    align-items: flex-start;
}

.suggestions-col {
    flex: 1;
    min-width: 0;
    max-height: 320px;
    overflow-y: auto;
}

.suggestions-col + .suggestions-col {
    border-left: 1px solid #f0f0f0;
}

.suggestions-col::-webkit-scrollbar {
    width: 4px;
}
.suggestions-col::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.suggestions-col::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
}

.suggestion-header {
    background: #f8f9fa;
    padding: 10px 15px;
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    color: #666;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    z-index: 1;
}

.suggestion-item {
    display: flex;
    align-items: center;
    padding: 9px 12px;
    text-decoration: none;
    color: #333;
    transition: background 0.2s;
    border-bottom: 1px solid #f5f5f5;
}

.suggestion-item:last-child {
    border-bottom: none;
}

.suggestion-item:hover {
    background: #fff4f0;
    color: #ff5e14;
}

.suggest-img-wrap {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background: #f8f9fa;
    border: 1px solid #eee;
}

.suggest-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.suggest-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
}

.suggest-title {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.suggest-subtitle {
    font-size: 11px;
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.suggestions-dropdown::-webkit-scrollbar {
    width: 6px;
}
.suggestions-dropdown::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}
.suggestions-dropdown::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 8px;
}

.suggestion-header:first-child {
    border-top: none;
    border-radius: 8px 8px 0 0;
}

.suggestion-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    text-decoration: none;
    color: #333;
    transition: background 0.2s;
    border-bottom: 1px solid #f5f5f5;
}

.suggestion-item:last-child {
    border-bottom: none;
}

.suggestion-item:hover {
    background: #fff4f0;
    color: #ff5e14;
}

.suggest-img-wrap {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
}

.suggest-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.suggest-content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.suggest-title {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.suggest-subtitle {
    font-size: 11px;
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.scale-up {
    animation: scale-up 0.3s ease-in-out;
}

@keyframes scale-up {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
